var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./VerbalDiscussionEnded.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-452ca41a!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./VerbalDiscussionEnded.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/tabs/DiscussionTab/VerbalDiscussionEnded.vue
// module id = 1790
// module chunks = 61